var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dad7e5;}.cls-2{fill:#edebf2;}.cls-3{fill:#9fdbf3;}.cls-4{fill:#b2e5fb;}.cls-5{fill:#c6c3d8;}.cls-6{fill:#fc6;}.cls-7{fill:#ffde76;}.cls-8{fill:#374f68;}.cls-9{fill:#7c7d7d;}.cls-10{fill:#919191;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Accounting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accounting"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,3V23H29a2,2,0,0,0-2,2H1V3A2,2,0,0,1,3,1H41A2,2,0,0,1,43,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43,3V23H26A22,22,0,0,1,4,1H41A2,2,0,0,1,43,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3,
    y: 3,
    width: 38,
    height: 20,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41,4V21H24A18.05,18.05,0,0,1,6,3H40A1,1,0,0,1,41,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,25v6H3a2,2,0,0,1-2-2V25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,25v4H8a4,4,0,0,1-4-4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 14,
    y: 31,
    width: 13,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,41c0,.1.61,0-11,0V33h3A8,8,0,0,1,25,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,41H13a1,1,0,0,1,0-2H27A1,1,0,0,1,27,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30,13A8,8,0,1,1,17.44,6.44,8,8,0,0,1,30,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M30,13a7.87,7.87,0,0,1-1.44,4.56A7.87,7.87,0,0,1,24,19,8,8,0,0,1,17.44,6.44,8,8,0,0,1,30,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23,28a1,1,0,0,0-2,0A1,1,0,0,0,23,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22,12a1,1,0,1,1,1-1,1,1,0,0,0,1,1c1.66,0,1.21-3-1-3.82a1,1,0,1,0-2,0A3,3,0,0,0,22,14a1,1,0,1,1-1,1,1,1,0,0,0-1-1c-1.66,0-1.21,3,1,3.82a1,1,0,1,0,2,0A3,3,0,0,0,22,12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 27,
    y: 23,
    width: 20,
    height: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M47,25c0,20.82-.1,20,0,20A18.05,18.05,0,0,1,29,27V23H45A2,2,0,0,1,47,25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30,
    y: 27,
    width: 14,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44,27v3H34a3,3,0,0,1-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,36H31a1,1,0,0,1,0-2h2A1,1,0,0,1,33,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,36H36a1,1,0,0,1,0-2h2A1,1,0,0,1,38,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,36H41a1,1,0,0,1,0-2h2A1,1,0,0,1,43,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,40H31a1,1,0,0,1,0-2h2A1,1,0,0,1,33,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,40H36a1,1,0,0,1,0-2h2A1,1,0,0,1,38,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,44H31a1,1,0,0,1,0-2h2A1,1,0,0,1,33,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,44H36a1,1,0,0,1,0-2h2A1,1,0,0,1,38,44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 38,
    width: 4,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44,39v4a3,3,0,0,1-3-3V38h2A1,1,0,0,1,44,39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/재경.bcfb3e665ef2fcfab55b2c5071d7dfba.svg";
export { ForwardRef as ReactComponent };